// extracted by mini-css-extract-plugin
export default {"textContainer":"Bifme","hubItemSkeletonContainer":"nVlXh","icon":"w34Qy","additionalInfoContainer":"BCUUM","iconContainer":"iHiZz","secondaryText":"VAvTg"};